import { useMutation } from '@tanstack/react-query';
import {
  UpdateBankOperationsStatusParams,
  updateBankOperationStatus,
} from 'config/requests/bankOperations';

export function useUpdateBankOperationsStatus() {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBankOperationsStatusParams }) =>
      updateBankOperationStatus(id, data),
  });
}
